//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './GDTOutgoingMessageClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type StoreOutgoingMessageGDTOutgoingMessageQueryParameters = {
  id: number ;
}

export type ProcessOutgoingMessageGDTOutgoingMessageQueryParameters = {
  id: number ;
}

export type SendMeasurementMessageGDTOutgoingMessageQueryParameters = {
  measurementId: number ;
}

export type SendDocumentMessageGDTOutgoingMessageQueryParameters = {
  documentId: string ;
}

export function storeOutgoingMessageUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/out-messages/{id}/stored";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function storeOutgoingMessageMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'GDTOutgoingMessageClient',
      'storeOutgoingMessage',
      id as any,
    ]);
}

/**
 * Updates GDT message status on Stored
 */
export function useStoreOutgoingMessageMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = storeOutgoingMessageMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.storeOutgoingMessage(id),
    mutationKey: key,
  });
}
  
type StoreOutgoingMessage__MutationParameters = StoreOutgoingMessageGDTOutgoingMessageQueryParameters

/**
 * Updates GDT message status on Stored
 */
export function useStoreOutgoingMessageMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, StoreOutgoingMessage__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: StoreOutgoingMessageGDTOutgoingMessageQueryParameters}): UseMutationResult<void, unknown, StoreOutgoingMessage__MutationParameters, TContext> {
  const key = storeOutgoingMessageMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: StoreOutgoingMessage__MutationParameters) => Client.storeOutgoingMessage(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function processOutgoingMessageUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/out-messages/{id}/processed";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function processOutgoingMessageMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'GDTOutgoingMessageClient',
      'processOutgoingMessage',
      id as any,
    ]);
}

/**
 * Updates GDT message status on Processed
 */
export function useProcessOutgoingMessageMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = processOutgoingMessageMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.processOutgoingMessage(id),
    mutationKey: key,
  });
}
  
type ProcessOutgoingMessage__MutationParameters = ProcessOutgoingMessageGDTOutgoingMessageQueryParameters

/**
 * Updates GDT message status on Processed
 */
export function useProcessOutgoingMessageMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ProcessOutgoingMessage__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ProcessOutgoingMessageGDTOutgoingMessageQueryParameters}): UseMutationResult<void, unknown, ProcessOutgoingMessage__MutationParameters, TContext> {
  const key = processOutgoingMessageMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ProcessOutgoingMessage__MutationParameters) => Client.processOutgoingMessage(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function sendMeasurementMessageUrl(measurementId: number): string {
  let url_ = getBaseUrl() + "/api/gdt/out-messages/measurement/{measurementId}";
if (measurementId === undefined || measurementId === null)
  throw new Error("The parameter 'measurementId' must be defined.");
url_ = url_.replace("{measurementId}", encodeURIComponent("" + measurementId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendMeasurementMessageMutationKey(measurementId: number): MutationKey {
  return trimArrayEnd([
      'GDTOutgoingMessageClient',
      'sendMeasurementMessage',
      measurementId as any,
    ]);
}

/**
 * Sends message regarding measurement
 */
export function useSendMeasurementMessageMutation<TContext>(measurementId: number, options?: Omit<UseMutationOptions<void, unknown, Types.SendGDTMessageDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SendGDTMessageDto, TContext> {
  const key = sendMeasurementMessageMutationKey(measurementId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.SendGDTMessageDto) => Client.sendMeasurementMessage(measurementId, dto),
    mutationKey: key,
  });
}
  
type SendMeasurementMessage__MutationParameters = SendMeasurementMessageGDTOutgoingMessageQueryParameters & {
  dto: Types.SendGDTMessageDto;
}

/**
 * Sends message regarding measurement
 */
export function useSendMeasurementMessageMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendMeasurementMessage__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendMeasurementMessageGDTOutgoingMessageQueryParameters}): UseMutationResult<void, unknown, SendMeasurementMessage__MutationParameters, TContext> {
  const key = sendMeasurementMessageMutationKey(options?.parameters?.measurementId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendMeasurementMessage__MutationParameters) => Client.sendMeasurementMessage(data.measurementId ?? options?.parameters?.measurementId!, data.dto),
  mutationKey: key,
});
}
  
export function sendDocumentMessageUrl(documentId: string): string {
  let url_ = getBaseUrl() + "/api/gdt/out-messages/document/{documentId}";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendDocumentMessageMutationKey(documentId: string): MutationKey {
  return trimArrayEnd([
      'GDTOutgoingMessageClient',
      'sendDocumentMessage',
      documentId as any,
    ]);
}

/**
 * Sends message regarding document
 */
export function useSendDocumentMessageMutation<TContext>(documentId: string, options?: Omit<UseMutationOptions<void, unknown, Types.SendGDTMessageDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SendGDTMessageDto, TContext> {
  const key = sendDocumentMessageMutationKey(documentId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.SendGDTMessageDto) => Client.sendDocumentMessage(documentId, dto),
    mutationKey: key,
  });
}
  
type SendDocumentMessage__MutationParameters = SendDocumentMessageGDTOutgoingMessageQueryParameters & {
  dto: Types.SendGDTMessageDto;
}

/**
 * Sends message regarding document
 */
export function useSendDocumentMessageMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendDocumentMessage__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendDocumentMessageGDTOutgoingMessageQueryParameters}): UseMutationResult<void, unknown, SendDocumentMessage__MutationParameters, TContext> {
  const key = sendDocumentMessageMutationKey(options?.parameters?.documentId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendDocumentMessage__MutationParameters) => Client.sendDocumentMessage(data.documentId ?? options?.parameters?.documentId!, data.dto),
  mutationKey: key,
});
}
  
export function getNotSentMessagesUrl(): string {
  let url_ = getBaseUrl() + "/api/gdt/out-messages/not-sent";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getNotSentMessagesDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, unknown, Types.PageableListDtoOfGDTMessageDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, unknown, Types.PageableListDtoOfGDTMessageDto>, 'queryFn'>> = {
};
export function getGetNotSentMessagesDefaultOptions() {
  return getNotSentMessagesDefaultOptions;
};
export function setGetNotSentMessagesDefaultOptions(options: typeof getNotSentMessagesDefaultOptions) {
  getNotSentMessagesDefaultOptions = options;
}

export function getNotSentMessagesQueryKey(): QueryKey;
export function getNotSentMessagesQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'GDTOutgoingMessageClient',
      'getNotSentMessages',
    ]);
}
export function __getNotSentMessages(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getNotSentMessages(
axiosConfig    );
}

/**
 * Gets not sent GDT outgoing messages. This method is only for the transporter.
We don't want to give the transporter access to all messages and filter them.
 */
export function useGetNotSentMessagesQuery<TSelectData = Types.PageableListDtoOfGDTMessageDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetNotSentMessagesQuery<TSelectData = Types.PageableListDtoOfGDTMessageDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfGDTMessageDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getNotSentMessages(context, axiosConfig) : __getNotSentMessages,
    queryKey: getNotSentMessagesQueryKey(),
    ...getNotSentMessagesDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets not sent GDT outgoing messages. This method is only for the transporter.
We don't want to give the transporter access to all messages and filter them.
 */
export function setGetNotSentMessagesData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfGDTMessageDto | undefined) => Types.PageableListDtoOfGDTMessageDto, ) {
  queryClient.setQueryData(getNotSentMessagesQueryKey(),
    updater
  );
}

/**
 * Gets not sent GDT outgoing messages. This method is only for the transporter.
We don't want to give the transporter access to all messages and filter them.
 */
export function setGetNotSentMessagesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfGDTMessageDto | undefined) => Types.PageableListDtoOfGDTMessageDto) {
  queryClient.setQueryData(queryKey, updater);
}